module.exports = __webpack_public_path__ + "static/media/1POLICY41.537acbee.jpg";